import { mapState } from "vuex";
import AQTechColorLogo from "@/assets/aqtech/Logo_AQTECH_horizontal_colorido.png";
import AQTechLogo from "@/assets/aqtech/aqtech_horizontal_branco.png";
import SAELogo from "@/assets/sae/logo_SAE_energia.png";
import AneelLogo from "@/assets/aneel/aneel_P&D_branco.png";
import AneelColorLogo from "@/assets/aneel/aneel_color_logo.png";
import i18n from "@/i18n";
import ToolBarService from "@/services/common/ToolBarService";
import RoutePathNames from "@/value-objects/routes/RoutePathNames";
import { SET } from "@/stores/CommumActionTypes";
import { CREATE_LOCALE_KEY } from "@/stores/locale/LocaleActionsTypes";

import
{
	ExtraLargeScreen,
	ExtraSmallScreen,
	LargeScreen,
	MediumScreen,
	SmallScreen,
} from "@/value-objects/devices/sizes/DeviceSize";

export default {
	components: {
		"tree-menu": () => import("@/components/menus/TreeMenu.vue"),
		"avatar":    () => import("@/components/toolbar/avatar/Avatar.vue"),
	},
	data: () => ({
		SAELogo,
		AneelLogo,
		AneelColorLogo,
		AQTechColorLogo,
		AQTechLogo,
		drawer:                false,
		title:                 process.env.VUE_APP_TITLE,
		toolbarComplementText: "",
	}),
	computed: {
		availableLanguages()
		{
			return [
				{ value: "en-US", language: i18n.t("Languages.English") },
				{ value: "es-419", language: i18n.t("Languages.LatinAmericaSpanish") },
				{ value: "pt-BR", language: i18n.t("Languages.BrazilianPortuguese") },
				{ value: "fr-FR", language: i18n.t("Languages.French") } ];
		},
		routeParams()
		{
			return this.$route.params;
		},
		titleSize()
		{
			const deviceSize = this.$vuetify.breakpoint.name;
			return this.SetTitleSize(deviceSize);
		},
		...mapState({
			ToolbarTreeMenu: "ToolbarTreeMenuModule",
			DarkMode:        "DarkMode",
			CompanyModule:   "CompanyModule",
			WindPark:        "WindPark",
			Locale:          (state) => state.Locale.locale,
		}),
	},
	watch: {
		routeParams()
		{
			this.GetToolbarText(this.$route.name);
		},
	},
	created()
	{
		this.$store.dispatch(`Locale/${CREATE_LOCALE_KEY}`);
	},
	mounted()
	{
		this.GetToolbarText(this.$route.name);
	},
	methods: {
		/**
		 * Altera o texto da toolbar de acordo com a rota selecionada
		 * @param {String} routeName nome da rota selecionada
		 */
		async GetToolbarText(routeName)
		{
			switch (routeName)
			{
			case RoutePathNames.Login:
				this.toolbarComplementText = "";
				break;
			case RoutePathNames.Home:
			case RoutePathNames.WindHomeTrends:
			case RoutePathNames.WindPark:
			case RoutePathNames.HydroElectricPowerPlant:
				this.toolbarComplementText = this.CompanyModule.company.name;
				break;
			case RoutePathNames.WindParkTrends:
				this.toolbarComplementText = `${this.CompanyModule.company.name} • ${this.WindPark.data.name}`;
				break;
			case RoutePathNames.WindTurbine:
			case RoutePathNames.WindAudio:
			case RoutePathNames.WindRegisters:
			case RoutePathNames.WindTrends:
			case RoutePathNames.HydroElectricGeneratingUnit:
			case RoutePathNames.HydroElectricTurbine:
			case RoutePathNames.HydroAudio:
			case RoutePathNames.HydroRegisters:
			case RoutePathNames.AirGap:
			case RoutePathNames.HydroTrends:
			case RoutePathNames.HydroEvents:
			case RoutePathNames.AnomalyDetection:
			case RoutePathNames.DiagnosticConfigurator:
			case RoutePathNames.NotificationConfiguration:
			case RoutePathNames.BladeDefect:
			case RoutePathNames.PressureFluctuation:
			case RoutePathNames.OilWhirl:
			case RoutePathNames.AngularMisalignment:
			case RoutePathNames.ParallelMisalignment:
			case RoutePathNames.Unbalance:
			case RoutePathNames.Looseness:
			case RoutePathNames.BearingPadsDefect:
			case RoutePathNames.StatorDefect:
			case RoutePathNames.OverhungRotor:
			case RoutePathNames.Rubbing:
			case RoutePathNames.MagneticFlux:
			case RoutePathNames.WindVDI:
			case RoutePathNames.PitchAnalysis:
			case RoutePathNames.HydroVDI:
			case RoutePathNames.WindOil:
			case RoutePathNames.HydroAudio:
			case RoutePathNames.WindLimitsSettings:
			case RoutePathNames.HydroLimitsSettings:
				this.toolbarComplementText = await ToolBarService.GetToolBarComplementaryText(
					this.$route.params.monitoringElementId
				);
				break;
			case RoutePathNames.Configurations:
				this.toolbarComplementText = i18n.t("Buttons.Settings");
				break;
			case RoutePathNames.UserConfigurations:
				this.toolbarComplementText = i18n.t("Buttons.UserSettings");
				break;
			case RoutePathNames.CompaniesConfigurations:
				this.toolbarComplementText = i18n.t("Buttons.CompaniesSettings");
				break;
			case RoutePathNames.Profile:
				this.toolbarComplementText = i18n.t("Buttons.UserProfile");
				break;
			case RoutePathNames.FrequencyTrendConfiguration:
				this.toolbarComplementText = i18n.t("Titles.TrendFrequencyComponent");
				break;
			case RoutePathNames.CompanyTrendLimitsConfiguration:
				this.toolbarComplementText = i18n.t("Titles.GlobalLimitsAndNotifications");
				break;
			case RoutePathNames.FrequencyTrendLimitConfiguration:
				this.toolbarComplementText = i18n.t("Titles.FrequencyLimitsAndNotifications");
				break;
			case RoutePathNames.ConstructionParameters:
				this.toolbarComplementText = i18n.t("Titles.KinematicParameters");
				break;
			case RoutePathNames.KinematicParametersConfiguration:
			case "KinematicConfiguration":
				this.toolbarComplementText = i18n.t("Titles.KinematicParameters");
				break;
			case RoutePathNames.AlarmManagement:
				this.toolbarComplementText = i18n.t("Titles.AlarmManagement");
				break;
			default:
				this.toolbarComplementText = "";
				break;
			}
		},

		/**
		 * Define o estilo do texto de acordo com o tamanho da tela
		 * @param {String} deviceSize String q denomina o padrão de tamanho de tela segundo o vuetify
		 * @return {String} estylo do texto
		 */
		SetTitleSize(deviceSize)
		{
			switch (deviceSize)
			{
			case SmallScreen:
			case ExtraSmallScreen:
				return "text-body-2";
			case MediumScreen:
				return "text-body-1";
			case LargeScreen:
				return "text-h5";
			case ExtraLargeScreen:
				return "text-h4";
			default:
				return "text-body-1";
			}
		},

		/**
		 * Cria o título da toolbar de acordo com a turbina acessada
		 * @return {String} titulo da toolbar
		 */
		BuildToolbarName()
		{
			const windPowerPlantName = this.Toolbar.data.monitoringElementParent.name.replace("-", "");
			const windTurbineName = this.Toolbar.data.name.replace("-", "");
			this.toolbarComplementText = `${windPowerPlantName} - ${windTurbineName}`;

			return this.toolbarComplementText;
		},

		/**
		 * Altera a linguagem da aplicação de acordo com a linguagem selecionada
		 * @param {String} selectedLanguage linguagem selecionada pelo usuário
		 */
		ChangeLanguage(selectedLanguage)
		{
			this.$store.dispatch(`Locale/${SET}`, selectedLanguage);
		},
	},
};